import { toast } from 'react-toastify';
import { toastError } from '../../../../utils';
import { callApi } from '../../../../apiCaller';
import { POPUP_TYPE, SYSTEM_ADMIN_PATH } from '../../../../constants';
import {
     setIsWaiting,
     setIsLoading,
     setRemoveLoading,
     setShowRemovePopup,
     setShowPopup,
     setShowPopupDetail,
     setShowRelatedObjectWarningPopup,
} from '../../../../actions/general';
import { setAdminSurveyDetails } from './Survey/actions';
import { setAdminDataAddProduct } from '../GlobalStates/DataAddProduct/actions';

export const ADD_ADMIN_SURVEY = 'addAdminSurvey';
export const ADD_ADMIN_SURVEYS = 'addAdminSurveys';
export const UPDATE_ADMIN_SURVEY = 'updateAdminSurvey';
export const DELETE_ADMIN_SURVEY = 'deleteAdminSurvey';
export const API_SYSTEM_ADMIN_SURVEYS = 'surveys';
export const API_SYSTEM_ADMIN_SURVEY = 'surveys/:id';
export const API_SYSTEM_ADMIN_SURVEY_DELETE_CHECKING = 'surveys/delete-checking/:id';
export const API_SYSTEM_ADMIN_DUPLICATE_SURVEY = 'surveys/duplicate';

export const addSystemAdminSurvey = (survey) => {
     return {
          type: ADD_ADMIN_SURVEY,
          payload: survey,
     };
};

export const addSystemAdminSurveys = (surveys) => {
     return {
          type: ADD_ADMIN_SURVEYS,
          payload: surveys,
     };
};

export const updateSystemAdminSurvey = (survey) => {
     return {
          type: UPDATE_ADMIN_SURVEY,
          payload: survey,
     };
};

const deleteSystemAdminSurvey = (surveyId) => {
     return {
          type: DELETE_ADMIN_SURVEY,
          payload: surveyId,
     };
};

export const addSurveyToDataAddProduct = (survey) => (dispatch, getState) => {
     const dataAddProduct = getState().admin.dataAddProduct;

     if (dataAddProduct?.surveys) {
          dataAddProduct.surveys.push(survey);
          dispatch(setAdminDataAddProduct(dataAddProduct));
     }
};

export const updateSurveyToDataAddProduct = (survey) => (dispatch, getState) => {
     const dataAddProduct = getState().admin.dataAddProduct;

     if (dataAddProduct !== null) {
          const newDataSurveys = dataAddProduct.surveys.map((surveyItem) => {
               const newSurvey = {
                    id: survey.id,
                    name: survey.name,
                    status: survey.status,
               };

               if (surveyItem.id === newSurvey.id) {
                    return { ...surveyItem, ...newSurvey };
               }

               return surveyItem;
          });

          dataAddProduct.surveys = newDataSurveys;
          dispatch(setAdminDataAddProduct(dataAddProduct));
     }
};

export const deleteSurveyFromDataAddProduct = (id) => (dispatch, getState) => {
     const dataAddProduct = getState().admin.dataAddProduct;

     if (dataAddProduct !== null) {
          const newSurveys = dataAddProduct.surveys.filter((survey) => survey.id !== id);
          dataAddProduct.surveys = newSurveys;
          dispatch(setAdminDataAddProduct(dataAddProduct));
     }
};

export const fetchSystemAdminSurveysRequest = () => (dispatch) => {
     dispatch(setIsLoading(true));

     callApi(API_SYSTEM_ADMIN_SURVEYS, 'GET')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               dispatch(addSystemAdminSurveys(response.data));
          })
          .catch((response) => {
               toastError(response);
          })
          .finally(() => dispatch(setIsLoading(false)));
};

export const addSystemAdminSurveyRequest = (survey) => (dispatch) => {
     dispatch(setIsWaiting(true));

     callApi(API_SYSTEM_ADMIN_SURVEYS, 'POST', survey)
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               const newSurvey = response.data;

               dispatch(addSystemAdminSurvey(newSurvey));
               dispatch(addSurveyToDataAddProduct(newSurvey));
               dispatch(setShowPopup());

               toast.success('Created Successfully');
          })
          .finally(() => {
               dispatch(setIsWaiting(false));
          });
};

export const updateSystemAdminSurveyRequest = (surveyId, newSurvey) => (dispatch, getState) => {
     const surveyDetails = getState().admin.surveyDetails;
     callApi(API_SYSTEM_ADMIN_SURVEY.replace(':id', surveyId), 'PUT', newSurvey)
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               const newSurvey = response.data;

               dispatch(updateSystemAdminSurvey(newSurvey));
               dispatch(updateSurveyToDataAddProduct(newSurvey));

               const newSurveyDetails = {
                    ...surveyDetails,
                    ...newSurvey,
               };
               dispatch(setAdminSurveyDetails(newSurveyDetails));

               toast.success('Update Successfully');
          })
          .finally(() => {
               dispatch(setIsWaiting(false));
               dispatch(setShowPopupDetail(null));
          });
};

export const deleteSystemAdminSurveyRequest = (id) => (dispatch) => {
     dispatch(setRemoveLoading(true));
     callApi(API_SYSTEM_ADMIN_SURVEY.replace(':id', id), 'DELETE')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               if (response.data.isUsedForProducts) {
                    dispatch(setShowRelatedObjectWarningPopup(POPUP_TYPE.WARNING_RELATED, response.data.message));
                    return;
               }

               dispatch(deleteSystemAdminSurvey(id));
               dispatch(deleteSurveyFromDataAddProduct(id));
               toast.success('Delete Successfully');
          })
          .finally(() => {
               dispatch(setRemoveLoading(false));
               dispatch(setShowRemovePopup(null));
          });
};

export const checkUpdateSurveyRequest = (nextDispatch) => (dispatch) => {
     const { checkedValue, setFieldValue, setStatus, setStatusLoading, surveyId } = nextDispatch;

     // Check status for delete only on edit page
     if (!surveyId) {
          setFieldValue('status', checkedValue);
          return;
     }

     // Check status for delete only on status = true
     if (checkedValue) {
          setFieldValue('status', checkedValue);
          return;
     }

     setStatusLoading(true);

     return callApi(`${API_SYSTEM_ADMIN_SURVEY_DELETE_CHECKING.replace(':id', surveyId)}`, 'GET')
          .then((response) => {
               if (response.status === 200 && response.data.canDelete) {
                    setFieldValue('status', checkedValue);
                    return;
               }

               if (response.data.isUsedForProducts) {
                    dispatch(setShowRelatedObjectWarningPopup(POPUP_TYPE.WARNING_RELATED, response.data.message));
                    setStatus(!checkedValue);
                    setFieldValue('status', !checkedValue);
                    return;
               }

               toastError(response);
          })
          .finally(() => setStatusLoading(false));
};

export const checkDeleteAdminSurveyRequest = (surveyId) => (dispatch) => {
     callApi(API_SYSTEM_ADMIN_SURVEY_DELETE_CHECKING.replace(':id', surveyId), 'GET').then((response) => {
          if (response.status === 200 && response.data.canDelete) {
               dispatch(setShowRemovePopup(surveyId));
               return;
          }

          if (response.data.isUsedForProducts) {
               dispatch(setShowRemovePopup(null));
               dispatch(setShowRelatedObjectWarningPopup(POPUP_TYPE.WARNING_RELATED, response.data.message));
          } else {
               toastError(response);
          }
     });
};

export const proceedRemoveAdminSurveyRequest =
     (surveyId, navigate = null) =>
     (dispatch) => {
          dispatch(setRemoveLoading(true));
          callApi(API_SYSTEM_ADMIN_SURVEY.replace(':id', surveyId), 'DELETE')
               .then((response) => {
                    if (response.status !== 200) {
                         toastError(response);
                         return;
                    }
                    dispatch(deleteSystemAdminSurvey(surveyId));
                    dispatch(deleteSurveyFromDataAddProduct(surveyId));
                    if (navigate) {
                         navigate(SYSTEM_ADMIN_PATH.SURVEYS, { replace: true });
                    }
                    toast.success('Delete Successfully');
               })
               .catch((response) => {
                    toastError(response);
               })
               .finally(() => {
                    dispatch(setRemoveLoading(false));
                    dispatch(setShowRemovePopup(null));
               });
     };

export const duplicateSurveyRequest = (surveyId) => (dispatch) => {
     dispatch(setIsWaiting(true));
     callApi(API_SYSTEM_ADMIN_DUPLICATE_SURVEY, 'POST', { surveyId })
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               const newSurvey = response.data;

               dispatch(addSystemAdminSurvey(newSurvey));
               dispatch(addSurveyToDataAddProduct(newSurvey));

               toast.success('Clone Successfully');
          })
          .finally(() => {
               dispatch(setIsWaiting(false));
          });
};
